// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e554d4bc","81":"98c17c71","294":"daf01e8b","301":"3ed55975","384":"734af73f","453":"258b012d","571":"5cc09895","785":"4a36f098","796":"bdaa2159"}[chunkId] + ".chunk.js";
};